import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import Bouton from '../../UI/Bouton/Bouton';
import S from './ProjetsTauxCriticite.module.scss';
import TableauComposantMaintenance from './TableauProjetsTauxCriticite/TableauComposantMaintenance';
import TableauProjetsTauxCriticite from './TableauProjetsTauxCriticite/TableauProjetsTauxCriticite';
import AttenteRequete from 'hoc/AttenteRequete/AttenteRequete';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';

interface ProjetsTauxCriticiteProps {
  start_interval?: number;
  end_interval?: number;
  criticity_id_list: string[];
  types_id_list: string[];
  toolsbar: React.ReactNode;
  sensorList: any[];
}

const ProjetsTauxCriticite: React.FC<ProjetsTauxCriticiteProps> = (props) => {
  const [montrerInfo, setMontrerInfo] = useState<boolean>(false);
  const [displayPopup, setDisplayPopup] = useState<boolean>(false);
  const [selectSensorId, setSelectSensorId] = useState<string>('');
  const [formattedSensorList, setFormattedSensorList] =
    useState<Map<any, any>>();

  useEffect(() => {
    const formattedData = new Map();
    if (props.sensorList?.length > 0) {
      props.sensorList.forEach((sensorComponent) => {
        const {
          detection_timestamp,
          timestamp_last_value,
          delay,
          criticity_level,
          project_name,
          sensor_id,
          position_in_sensor,
          prefix,
          sensor_name,
          sensor_type,
          sensor_group,
        } = sensorComponent;

        if (formattedData.has(sensor_id)) {
          formattedData
            .get(sensor_id)
            .component.add(
              `${position_in_sensor}${prefix ? '-' + prefix : ''}`
            );
        } else {
          const tempComponentSet = new Set().add(
            `${position_in_sensor}${prefix ? '-' + prefix : ''}`
          );
          formattedData.set(sensor_id, {
            id: sensor_id,
            detectionTimestamp: detection_timestamp,
            timestampLastValue: timestamp_last_value,
            delay,
            criticityLevel: criticity_level,
            projectName: project_name,
            sensorName: sensor_name,
            sensorType: sensor_type,
            sensorGroup: sensor_group,
            component: tempComponentSet,
          });
        }
      });
      setFormattedSensorList(formattedData);
    } else {
      setFormattedSensorList(new Map());
    }
  }, [props.sensorList]);

  useEffect(() => {
    if (selectSensorId) {
      setDisplayPopup(true);
    } else {
      setDisplayPopup(false);
    }
  }, [selectSensorId]);

  const creerVue = () => {
    setMontrerInfo(true);
  };

  const afficherPopup = (id: string) => {
    setSelectSensorId(id);
  };

  //initialisation des varable de style
  let styleConteneurCentralGauche = [S.ConteneurCentralGauche];
  let styleConteneurCentralDroite = [S.ConteneurCentralDroite];

  if (montrerInfo) {
    //style pour un conteneur info ouvert
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteOuvert);
    // styleConteneurCentralDroite.push(S.ConteneurCentralGaucheOuvert);
  } else {
    //style pour un conteneur info fermé
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFermer);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheFermer);
  }

  if (montrerInfo) {
    //conteneur info ouvert & plein écran
    //on met la largeur à 100% du conteneur info
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFull);
    //on réduit à zéro la largeur du conteneur central
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheVoid);
  } else if (montrerInfo) {
    //conteneur info ouvert & !plein écran
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteOuvert);
  } else {
    //conteneur info fermé
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFermer);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheFermer);
  }
  return (
    <>
      <AttenteRequete
        request_type={requestType.recuperer_objet_projets_taux_de_pannes}
        str={'Récupération des données de maintenance'}
      >
        <Modal
          isOpen={displayPopup}
          overlayClassName={S.PopupMaintenanceOverlay}
          style={{
            content: {
              width: '60%',
              height: '70%',
              margin: 'auto',
            },
          }}
          contentLabel="Popup"
        >
          <div className={S.PopupMaintenance}>
            <h2>Information sur le capteur</h2>
            <p>Id du capteur: {selectSensorId}</p>
            {props.sensorList?.length > 0 && (
              <TableauComposantMaintenance
                data={props.sensorList?.filter(
                  (sensor: any) => sensor.sensor_id === selectSensorId
                )}
              />
            )}
            <Bouton
              type_btn={type_btn.fermer}
              cliquer={() => setSelectSensorId('')}
            >
              Fermer
            </Bouton>
          </div>
        </Modal>
        <div className={styleConteneurCentralGauche.join(' ')}>
          <TableauProjetsTauxCriticite
            creer={creerVue}
            sensorList={
              formattedSensorList instanceof Map && formattedSensorList.size > 0
                ? Array.from(formattedSensorList.values())
                : []
            }
            clickSensor={afficherPopup}
          >
            {props.toolsbar}
          </TableauProjetsTauxCriticite>
        </div>
      </AttenteRequete>
    </>
  );
};

export default ProjetsTauxCriticite;
